import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {CapitalizePipe} from '../../../core/pipes/capitalize.pipe';
import {MatTooltip} from '@angular/material/tooltip';
import {ActivatedRoute, RouterLink, UrlSegment} from '@angular/router';
import {CommonModule, NgClass} from '@angular/common';
import {MatIcon, MatIconRegistry} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MenuDataService} from './menu-data.service';
import {DomSanitizer} from '@angular/platform-browser';
import {CurrentUserService} from '../../../core/services/user.service';
import {AccessService, guideKeys} from '../../../core/services/access.service';
import {AccessitemDirective} from './accessitem.directive';
import {UserPermissionsService} from '../../../core/services/user-permissions.service';
import {LiCounterDirective} from './li-counter.directive';

@Component({
  selector: 'ostso-side-bar-double',
  standalone: true,
  imports: [
    CapitalizePipe,
    MatTooltip,
    RouterLink,
    NgClass,
    MatIcon,
    MatIconButton,
    MatProgressSpinner,
    AccessitemDirective,
    CommonModule,
    LiCounterDirective,
  ],
  templateUrl: './side-bar-double.component.html',
  styleUrl: './side-bar-double.component.scss'
})
export class SideBarDoubleComponent implements OnInit {
  @Input() type: string = '';
  @Input() titleCreate: string = 'Создать заявку';
  @Output() toggle = new EventEmitter();
  @Output() clickOutside = new EventEmitter();
  @Output() createNew = new EventEmitter();

  @Input() opened = false;


  @HostListener('document:click', ['$event']) docClick(event: MouseEvent): void {
    const isSelfTarget = (event.target as HTMLElement).closest('mat-sidenav');
    if (isSelfTarget) return;
    this.clickOutside.emit();
  }

  showCreateButton = true; //для скрытия кнопки "создать" на grade компоненте
  isNewEnabled = false; //для скрытия кнопки в зависимости от прав доступа
  isShowReestButton = false;
  canCreate = false;

  constructor(
    public menuData: MenuDataService,
    public user: CurrentUserService,
    public route: ActivatedRoute,
    public accessService: AccessService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private permissionsService: UserPermissionsService,
  ) {
    this.menuData.list.forEach(item => {
      iconRegistry.addSvgIcon(
        item.href,
        sanitizer.bypassSecurityTrustResourceUrl(item.icon)
      );
    })
    this.menuData.reports.forEach(item => {
      iconRegistry.addSvgIcon(
        item.href,
        sanitizer.bypassSecurityTrustResourceUrl(item.icon)
      );
    })
    this.menuData.admin.forEach(item => {
      iconRegistry.addSvgIcon(
        item.href,
        sanitizer.bypassSecurityTrustResourceUrl(item.icon)
      );
    })

    this.route.url.subscribe((url: UrlSegment[]) => {
      if ((['group', 'subgroup', 'kind', 'remarktype', 'ratecard']).includes(url[0].path)) {
        this.accessService.newButton.subscribe((v: any) => {
          this.isNewEnabled = v[url[0].path as guideKeys];
        });
      }
      console.log({url: url[0].path});
    });
    this.route.data.subscribe(data => {
      console.log('route data',data);
      this.canCreate = data['canCreate'];
    })
  }

  toggleEmit(): void {
    this.toggle.emit();
  }

  ngOnInit(): void {
    !this.user.value.lastName && !this.user.value.firstName && this.user.fetchUser();
    this.route.url.subscribe(url => {
      if (url[0].path !== 'grade' || url[1] !== undefined || (url[0].path as string)=== 'users') {
        this.showCreateButton = true;
        return
      }

      this.showCreateButton = !!this.permissionsService.permissons$.value?.create?.grade;
    });

    this.isShowReestButton = !!this.permissionsService.permissons$.value?.view?.grade
    this.permissionsService.permissons$.subscribe(permissons => {
      this.isShowReestButton = !!permissons?.view?.grade

    })
  }


}
